import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaGift, FaCog, FaHome, FaAngleRight, FaSignOutAlt, FaShieldAlt, FaCircle
} from 'react-icons/fa';
import './css/Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({
    bonuslar: true,
    ayarlar: false
  });

  useEffect(() => {
    if (location.pathname.includes('requests')) setOpenMenus(p => ({ ...p, bonuslar: true }));
    if (location.pathname.includes('settings') || location.pathname.includes('site')) setOpenMenus(p => ({ ...p, ayarlar: true }));
  }, [location.pathname]);

  const toggleMenu = (menu) => setOpenMenus(prev => ({ ...prev, [menu]: !prev[menu] }));
  const isActive = (path) => location.pathname === path ? 'active' : '';

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <div className="sidebar">
      <div className="sidebar-brand">
        <div className="brand-icon"><FaShieldAlt /></div>
        <div className="brand-text">
          <span className="brand-title">Antik</span>
          <span className="brand-subtitle">Yönetim Paneli</span>
        </div>
      </div>

      <nav className="sidebar-scroll">
        {/* Ana Menü */}
        <div className="menu-section">
          <span className="section-title">Ana Menü</span>
          <Link to="/dashboard" className={`nav-link ${isActive('/dashboard')}`}>
            <FaHome className="icon" />
            <span>Dashboard</span>
          </Link>
        </div>

        {/* İşlemler */}
        <div className="menu-section">
          <span className="section-title">İşlemler</span>
          <div className={`nav-collapse ${openMenus.bonuslar ? 'expanded' : ''}`}>
            <div className="collapse-header" onClick={() => toggleMenu('bonuslar')}>
              <div className="header-left">
                <FaGift className="icon" />
                <span>Bonus Talepleri</span>
              </div>
              <FaAngleRight className="chevron" />
            </div>
            <div className="collapse-body">
              <Link to="/pending-requests" className={`sub-link ${isActive('/pending-requests')}`}>
                <i className="dot blue" /> <span>Bekleyenler</span>
              </Link>
              <Link to="/completed-requests" className={`sub-link ${isActive('/completed-requests')}`}>
                <i className="dot green" /> <span>Onaylananlar</span>
              </Link>
              <Link to="/rejected-requests" className={`sub-link ${isActive('/rejected-requests')}`}>
                <i className="dot red" /> <span>Reddedilenler</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Sistem */}
        <div className="menu-section">
          <span className="section-title">Sistem</span>
          <div className={`nav-collapse ${openMenus.ayarlar ? 'expanded' : ''}`}>
            <div className="collapse-header" onClick={() => toggleMenu('ayarlar')}>
              <div className="header-left">
                <FaCog className="icon" />
                <span>Ayarlar</span>
              </div>
              <FaAngleRight className="chevron" />
            </div>
            <div className="collapse-body">
              <Link to="/settings/bonuses" className={`sub-link ${isActive('/settings/bonuses')}`}>
                <i className="dot" /> <span>Bonus Yönetimi</span>
              </Link>

              <Link to="/site-settings" className={`sub-link ${isActive('/site-settings')}`}>
                <i className="dot" /> <span>Genel Ayarlar</span>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="sidebar-footer">
        <div className="user-card">
          <div className="avatar">AD</div>
          <div className="user-details">
            <span className="name">User</span>
            <span className="role">Admin</span>
          </div>
        </div>
        <button className="logout-button" onClick={handleLogout}>
          <FaSignOutAlt /> <span>Güvenli Çıkış</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;